<template>
  <b-navbar-nav class="m-auto">
    <b-nav-form>
      <b-form-input
        v-model="value"
        @keyup="search(value)"
        size="sm"
        class="ml-sm-1 form-control-rounded"
        placeholder="جستجو"
      ></b-form-input>
      <b-button size="sm" class="my-2 my-sm-0 btn-danger rounded-pill" type="submit">جستجو</b-button>
    </b-nav-form>
  </b-navbar-nav>
</template>

<script>
export default {
  name: "search-component",
  data() {
    return {
      value: "",
    };
  },

  methods: {
    search(value) {
      this.$store.dispatch("localSearch", value);
    },
  },
};
</script>

